export class GetAllConfigs {
    constructor() {
        this.handle = async () => {
            const apiUrl = process.env.REACT_APP_API_URL;
            try {
                const url = new URL(`/configurations`, apiUrl);
                const response = await fetch(url.toString(), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                const data = await response.json();
                return data;
            }
            catch (error) {
                console.error(error);
                return [];
            }
        };
    }
}
export default GetAllConfigs;
